import * as React from 'react';
import styles from './styles.module.styl';
export var SearchField = function (_a) {
    var value = _a.value, placeholder = _a.placeholder, onChange = _a.onChange;
    return (React.createElement("div", { className: styles.searchContainer },
        React.createElement("form", { id: "search", role: "search", autoComplete: "off" },
            React.createElement("div", { className: "form-group search-control" },
                React.createElement("i", { className: "icon-budicon-489 search-icon" }),
                React.createElement("input", { id: "search-input", type: "text", className: "search-input form-control", value: value, placeholder: placeholder, onChange: onChange })))));
};
